import { FetchProfile, UpdateProfile } from "../../Services/MainServices";
import { toast } from "react-toastify";

export const USER_PROFILE_FETCH_REQUEST = "USER_PROFILE_FETCH_REQUEST";
export const USER_PROFILE_FETCH_SUCCESS = "USER_PROFILE_FETCH_SUCCESS";
export const USER_PROFILE_FETCH_FAILURE = "USER_PROFILE_FETCH_FAILURE";

export const UPDATE_USER_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_FAILURE = "UPDATE_USER_PROFILE_FAILURE";

export const AUTH_SESSION_EXPIRED = "AUTH_SESSION_EXPIRED";

const fetchUserProfileRequest = () => ({
  type: USER_PROFILE_FETCH_REQUEST,
});

const fetchUserProfileSuccess = (profile) => ({
  type: USER_PROFILE_FETCH_SUCCESS,
  payload: profile,
});

const fetchUserProfileFailure = (error) => ({
  type: USER_PROFILE_FETCH_FAILURE,
  payload: error,
});

export const fetchUserProfile = () => async (dispatch) => {
  dispatch(fetchUserProfileRequest());
  try {
    const response = await FetchProfile();
    const api = response.data.data;

    if (!api) throw new Error("No profile data returned");

    const normalized = {
      fullName: api.vendor_name != null ? api.vendor_name : api.customer_name,
      email: api.email_id,
      gender: api.gender,
      mobileNo: api.mobile_no?.toString() || "",
      vendor_shop_name: api.vendor_shop_name || null,
      vendor_gst: api.gst_number || null,
      address: api.address || null,
      pinCode: api.pin_code || null,
      role: api.vendor_name != null ? "vendor" : "customer",
      sales_person: {
        first_name: api.sales_person?.first_name || null,
        email: api.sales_person?.email || null,
        phone: api.sales_person?.phone || null,
      },
    };

    dispatch(fetchUserProfileSuccess(normalized));

    // toast.success('User profile loaded successfully');
  } catch (error) {
    // Check for auth error (401)
    if (error.response?.status === 401) {
      const msg = "Session expired. Please log in again.";
      dispatch({ type: AUTH_SESSION_EXPIRED, payload: msg });
      toast.error(msg);
      return { type: AUTH_SESSION_EXPIRED };
    }

    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch profile";

    dispatch(fetchUserProfileFailure(message));
    // toast.error(message);
  }
};

export const updateUserProfileRequest = () => ({
  type: UPDATE_USER_PROFILE_REQUEST,
});

export const updateUserProfileSuccess = (data) => ({
  type: UPDATE_USER_PROFILE_SUCCESS,
  payload: data,
});

export const updateUserProfileFailure = (error) => ({
  type: UPDATE_USER_PROFILE_FAILURE,
  payload: error,
});

export const updateUserProfile = (localState) => async (dispatch) => {
  dispatch(updateUserProfileRequest());
  try {
    const nameField =
      localState.role === "vendor" ? "vendor_name" : "customer_name";

    const payload = {
      [nameField]: localState.fullName,
      email_id: localState.email,
      mobile_no: localState.mobileNo,
      gender: localState.gender,
      pin_code: localState.pinCode,
      address: localState.address,
      gst_number: localState.vendor_gst,
      vendor_shop_name: localState.vendor_shop_name,
    };

    const response = await UpdateProfile(payload);
    // console.log("Response: ",response)
    if (response?.data?.status === "success") {
      // Normalize returned data
      const data = response.data.data;
      const updated = {
        fullName: data.vendor_name ?? data.customer_name,
        mobileNo: data.mobile_no?.toString() || "",
        email: data.email_id,
        gender: data.gender,
        pinCode: data.pin_code,
        address: data.address,
        vendor_gst: data.gst_number,
        vendor_shop_name: data.vendor_shop_name,
      };
      const action = dispatch(updateUserProfileSuccess(updated));
      toast.success("Profile updated successfully");
      // Return the dispatched success action so component .then(res).type works
      return action;
    } else {
      throw new Error(response?.data?.message || "Unexpected response");
    }
  } catch (error) {
    if (error.response?.status === 401) {
      const msg = "Session expired. Please log in again.";
      dispatch({ type: AUTH_SESSION_EXPIRED, payload: msg });
      toast.error(msg);
      return { type: AUTH_SESSION_EXPIRED };
    }
    const message =
      error.response?.data?.message || error.message || "Profile update failed";
    const action = dispatch(updateUserProfileFailure(message));
    // toast.error(message);
    return action;
  }
};
